module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "down-view",
    attrs: {
      "id": "home-page"
    }
  }, [_c('div', [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/mixsii-logo.svg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "font-large"
  }, [_vm._v("Mixsii is for sale. Email MixsiiDomain@proton.me to send an offer.")]), _vm._v(" "), _c('p', {
    staticClass: "font-large"
  }, [_vm._v("Domain, Code, and Graphical Assets are included. User Data is not.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-002fbc21"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/HomePage/HomePageDownView.vue
// module id = 385
// module chunks = 1